module.exports = "/076c958321237351e457a25f1551005dcff1e8fc/41880799fe091bc1302b42c64710352a.svg";